export default function arrayPrototypeAt(array: any[], index: number): any {
  // Convert the index to an integer
  index = Math.trunc(index) || 0
  // Handle negative index
  if (index < 0)
    index += array.length
    // Return undefined if index is out of bounds
  if (index < 0 || index >= array.length)
    return undefined
    // Return the element at the given index
  return array[index]
}
